/**
 * The pages a hosted reader reaches from the sidebar beside their threads. The thread
 * sidebar stays on them, and inside the HeyDay News app they remain HeyDex's own.
 */
import { ArchiveIcon, LibraryIcon, type LucideIcon } from "lucide-react";

export const READER_PAGES: ReadonlyArray<{
  readonly to: "/library" | "/archive";
  readonly label: string;
  readonly icon: LucideIcon;
}> = [
  { to: "/library", label: "Library", icon: LibraryIcon },
  { to: "/archive", label: "Archive", icon: ArchiveIcon },
];

export const LICENSES_PAGE = "/licenses";
